"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { useTheme as c } from "../../hooks.js";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: n, size: e = 24 } = _param, i = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const h = s(), r = n !== null && n !== void 0 ? n : h ? o.colors.inverse : o.colors.neutralHigh, { skinName: a } = c();
    return a.match(/^blau/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ t("path", {
                fill: r,
                d: "M11.992 17.86a1.2 1.2 0 0 1 0-2.4 1.2 1.2 0 0 1 0 2.4M11.324 6.068h1.356V14h-1.356z"
            }),
            /* @__PURE__ */ t("path", {
                fill: r,
                d: "M12 2c5.328 0 10 4.672 10 10s-4.672 10-10 10S2 17.328 2 12 6.672 2 12 2m0 18.644c4.604 0 8.644-4.04 8.644-8.644S16.604 3.356 12 3.356 3.356 7.396 3.356 12s4.04 8.644 8.644 8.644"
            })
        ]
    })) : a.match(/^o2-new/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ t("path", {
                fill: r,
                d: "M12 6.644a.72.72 0 0 0-.716.716v6.784c0 .392.32.716.716.716.392 0 .716-.32.716-.716V7.36A.72.72 0 0 0 12 6.644M12 15.928a.892.892 0 1 1 0 1.784.892.892 0 0 1 0-1.784"
            }),
            /* @__PURE__ */ t("path", {
                fill: r,
                d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12m1.428 0c0 4.716 3.856 8.572 8.572 8.572s8.572-3.856 8.572-8.572S16.716 3.428 12 3.428 3.428 7.284 3.428 12"
            })
        ]
    })) : a.match(/^o2/i) ? /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: [
            /* @__PURE__ */ t("path", {
                fill: r,
                d: "M12 6.644a.72.72 0 0 0-.716.716v6.784c0 .392.32.716.716.716.392 0 .716-.32.716-.716V7.36A.72.72 0 0 0 12 6.644M12 15.928a.892.892 0 1 1 0 1.784.892.892 0 0 1 0-1.784"
            }),
            /* @__PURE__ */ t("path", {
                fill: r,
                d: "M2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10S2 17.5 2 12m1.428 0c0 4.716 3.856 8.572 8.572 8.572s8.572-3.856 8.572-8.572S16.716 3.428 12 3.428 3.428 7.284 3.428 12"
            })
        ]
    })) : /* @__PURE__ */ t("svg", _object_spread_props(_object_spread({
        width: e,
        height: e,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, i), {
        children: /* @__PURE__ */ t("path", {
            fill: r,
            d: "M23 12.03C23 1.914 14.617 1.063 12.46 1.013c-.257-.01-.554-.013-.842-.013h-.2C9.21 1.019 1 1.776 1 11.964c0 10.2 8.29 10.998 10.496 11.033a12 12 0 0 1 .344.003c.232 0 .464-.003.664-.006C14.601 22.954 23 22.167 23 12.03m-1.374-.003c0 8.5-6.396 9.536-9.147 9.587-.194.003-.416.006-.645.006l-.322-.003c-2.749-.038-9.14-1.058-9.14-9.656 0-8.58 6.332-9.562 9.055-9.587h.191c.276 0 .56.003.808.01 2.767.065 9.2 1.139 9.2 9.643m-9.63 3.878a.69.69 0 0 1-.688-.689V5.72a.689.689 0 0 1 1.377 0v9.496a.693.693 0 0 1-.688.689m.787 1.718a.787.787 0 0 0-.786-.783.784.784 0 0 0 0 1.568H12a.79.79 0 0 0 .783-.785"
        })
    }));
}, g = m;
export { g as default };
